import React from "react";
import {navLinks} from "../../lib/utils";
import {Link, NavLink} from "react-router-dom";
import logo from "../../media/logo.png"

const LandingHeader = () => {
    return (
        <div className="navigation">
            <div className="header">
                <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease"
                     data-easing2="ease" role="banner" className="navbar w-nav">
                    <div className="nav-container position-relative">
                        <div className="navbar-wrapper">
                            <Link to="/" aria-current="page" className="navbar-brand w-nav-brand w--current">
                                {/*The logo*/}
                                <img loading="lazy" src={logo} alt="" className="logo h-[70px] w-24 max-h-[70px] max-w-24"/>
                            </Link>
                            <nav role="navigation" className="nav-menu-wrapper w-nav-menu">
                                <ul role="list" className="nav-menu w-list-unstyled">
                                    {/*Navigation links*/}
                                    {navLinks.map((item, index) => (
                                        <li key={index}>
                                            <NavLink
                                                to={item.url}
                                                className={({ isActive }) =>
                                                    (isActive ?
                                                        "nav-item body-text-16 medium text-neutral-05 w--current"
                                                        :
                                                        "nav-item body-text-16 medium")}>
                                                {item.title}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                            <div className="navbar-button">
                                {/*Login*/}
                                <Link id="w-node-a7fa2e15-3961-4ff9-f25d-ddea95182df9-95182df9" to="/login"
                                   className="button stoke w-inline-block">
                                    <p className="button-text primary">
                                        Login<br/>
                                    </p>
                                </Link>
                            </div>
                            <div className="menu-button w-nav-button">
                                <div data-w-id="2b0a520d-14c9-fa1b-bc33-c9195a58903d" className="menu-icon-wrapper">
                                    <img loading="lazy"
                                         src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e6a7177cfb2ef43a6de2a6_menu-01.svg"
                                         alt="" className="menu-icon"/>
                                    <img loading="lazy"
                                         src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e6a717f04fad8bb502c10f_x-close.svg"
                                         alt="" className="x-icon"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {LandingHeader};